import React, { Component } from 'react';
import {getQueryVariable} from './history';

import firebase from './firebase';

class LogoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ""
    }
  }
  componentWillMount() {
    firebase.auth().signOut().then(function() {
      window.location=getQueryVariable("next") || '/';
    }, function(error) {
      this.setState({error: error})
    });
  }

  render() {
    return (
      <div>
        <div>Logging out...</div>
        <div>{this.state.error}</div>
      </div>
    );
  }
}

export default LogoutPage;



// WEBPACK FOOTER //
// ./src/LogoutPage.js